import { Routes, Route, Navigate } from "react-router-dom";
import AdminTeamList from "./AdminTeamList";
import AdminTeamInvite from "./AdminTeamInvite";
import AdminTeamMember from "./AdminTeamMember";

export default function AdminTeamRoutes() {
  return (
    <Routes>
      <Route index element={<AdminTeamList />} />
      <Route path="invite" element={<AdminTeamInvite />} />
      <Route path="members/:userId" element={<AdminTeamMember />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
